import {useRef, useState} from 'react';
import toast from 'react-hot-toast';
import {useUploadBulkQuestionsMutation} from '../api/candidateTest';
import {invalidateQueryV2} from '../services/reactQuery';
import Modal from './common/Modal';
import Button from './ui/Button';
import InputField from './ui/InputField';

const BulkQuestionUpload = (props) => {
  const ref = useRef();
  const [isFileUploaded, setIsFileUploaded] = useState(true);

  const {mutate: uploadBulkQueMutation, isLoading: uploading} =
    useUploadBulkQuestionsMutation();

  const handleUpload = () => {
    if (ref.current?.files[0]) {
      setIsFileUploaded(true);
      const formData = new FormData();
      formData.append('excelFile', ref.current?.files[0]);

      uploadBulkQueMutation(formData, {
        onSuccess: () => {
          invalidateQueryV2('questions');
          toast.success('Bulk questions uploaded succesfully');
          props.onClose();
        },
        onError: (data) => toast.error(data.response.data.message),
      });
    } else {
      setIsFileUploaded(false);
    }
  };

  return (
    <Modal {...props} containerClassName="max-w-[600px]">
      <div className="py-3 flex flex-col gap-7">
        <div>
          <label
            htmlFor="bulkQuestions"
            className="font-semibold pb-2 inline-block"
          >
            Excelsheet
          </label>
          <InputField
            ref={ref}
            id="bulkQuestions"
            type="file"
            onClick={(e) => (e.target.value = null)}
          />
          {!isFileUploaded && (
            <div className="text-error text-sm pt-1">File ie required</div>
          )}
        </div>
        <Button type="button" onClick={handleUpload} loading={uploading}>
          Uplaod
        </Button>
      </div>
    </Modal>
  );
};

export default BulkQuestionUpload;
